/**
 * Central Cal.com scheduling configuration.
 * Public link: https://cal.com/go-higher
 */
export const CAL_COM_LINK =
  process.env.REACT_APP_CAL_COM_LINK || "go-higher";
export const CAL_COM_URL = `https://cal.com/${CAL_COM_LINK}`;
export const CAL_NAMESPACE = "gohigher";

/**
 * Loads the Cal.com embed script exactly once. Safe to call from multiple
 * components — subsequent calls are no-ops. Resolves when window.Cal is ready.
 */
export function loadCalCom() {
  if (typeof window === "undefined") return Promise.resolve(null);
  if (window.Cal && window.Cal.ns?.[CAL_NAMESPACE]) {
    return Promise.resolve(window.Cal);
  }
  // Official Cal.com embed loader snippet, transcribed
  (function (C, A, L) {
    let p = function (a, ar) { a.q.push(ar); };
    let d = C.document;
    C.Cal =
      C.Cal ||
      function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else {
            p(cal, ar);
          }
          return;
        }
        p(cal, ar);
      };
  })(window, "https://app.cal.com/embed/embed.js", "init");

  window.Cal("init", CAL_NAMESPACE, { origin: "https://cal.com" });

  // Brand + theme
  window.Cal.ns[CAL_NAMESPACE]("ui", {
    cssVarsPerTheme: {
      light: { "cal-brand": "#10B981" },
      dark: { "cal-brand": "#10B981" },
    },
    hideEventTypeDetails: false,
    layout: "month_view",
  });

  return Promise.resolve(window.Cal);
}
